import { AfterViewInit, Component, ViewChild } from '@angular/core';
import Swiper, { Autoplay, EffectFade, Navigation, Pagination, Scrollbar, SwiperOptions } from 'swiper';
import { SwiperComponent } from 'swiper/types';

Swiper.use([Navigation, Pagination, Autoplay, Scrollbar, EffectFade])

@Component({
  selector: 'app-swiper-why',
  templateUrl: './swiper-why.component.html',
  styleUrls: ['./swiper-why.component.scss'],
})
export class SwiperWhyComponent {

  @ViewChild('swiper', { static: false }) swiper: SwiperComponent
  config: SwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: { delay: 3000 },
    pagination: { clickable: true },
    navigation: true,
    centeredSlides: true,
    loop: true
  }

}
